import { makeStyles } from '@material-ui/core/styles';

const textDefault = (theme) => ({
  color: theme.palette.text.primary,
});
const useStyles = makeStyles((theme) => ({
  title: {
    ...textDefault(theme),
    textDecoration: 'underline',
    fontWeight: '500',
    fontSize: '1.125rem',
    marginBottom: '2rem',
    marginTop: '1rem',
  },
  errorIcon: {
    display: 'flex',
    color: theme.palette.error.main,
  },
  clientSelector: {
    width: '20%',
  },
  jurisdictions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
    marginLeft: '1rem',
  },
  jurisdiction: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  tooltip: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
  },
}));

export default useStyles;
